import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";

import {
  HRService,
  setupManagementUrl,
  userManagementUrl,
} from "../../../../config";

import DynamicForm from "../../../../data/Axios/DynamicForm";
import { CompanyCalendarSetupsFormFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { allRecurringStatus } from "../../../../data/Queries/HRmanagement/leavemanagement";
import { fetchJson } from "../../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = HRService.uri;

const CalendarSetupForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [leaveTypes, setLeaveTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
 const formatDate = (date) => {
    if (!date) return null; // Handle null or undefined dates
    return date.split("T")[0]; // Extract the date part
  };
  const initialValues = {
    recurringTypeId: props.data ? props.data.RecurringTypeId : "",
    holiday: props.data ? props.data.Holiday : "",
    holidayDate: props.data ? formatDate(props.data.HolidayDate) : "",
  
    id: props.data ? props.data.Id : '',

  };

  async function fetchLeaveTypes() {
    try {
       const data = await fetchJson({
        objectName: "allRecurringTypes", 
        baseUrl: HRService.uri,
      });
    
      if (data) {
        setLeaveTypes(JSON.parse(data.results) || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    let isMounted = true;
    fetchLeaveTypes();
    return () => {
      isMounted = false;
    };
  }, []);

  const LeaveTypeOptions = leaveTypes
    ? leaveTypes.map((type) => ({
        value: type.Id,
        label: type.Type,
      }))
    : [];
 
    const fields = [
  ...CompanyCalendarSetupsFormFields,
    {
      name: "recurringTypeId",
      label: "Recurring Type",
      type: "select",
      options: LeaveTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: false,
    },
   
  ];

 const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const { recurringTypeId, holiday, holidayDate } = values;

    const selectedLeaveType = LeaveTypeOptions.find(
      (type) => type.value === recurringTypeId
    );

    const mutationData = {
      recurringTypeId: recurringTypeId || null,
      holiday,
      holidayDate,
      recurringType: selectedLeaveType?.label || null,
    };

    if (props.isEditing) {
      mutationData.id = props.data.Id;
    }

    const response = await generateAndExecuteMutation(
      props.isEditing
        ? "updateCompanyCalendarSetup"
        : "createCompanyCalendarSetup",
      mutationData,
      "setup",
      base_url
    );

    const resultKey = props.isEditing
      ? "updateCompanyCalendarSetup"
      : "createCompanyCalendarSetup";

    const result = response?.[resultKey];

    if (result?.results != null) {
      props.onClose();
      props.onAction();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: `Company Calendar Setup ${props.isEditing ? "updated" : "added"} successfully.`,
      });
    } else {
      const errorObj = result?.error ? JSON.parse(result.error) : null;
      if (
        errorObj?.Error?.includes("duplicate key value") &&
        errorObj?.Error?.includes("uq_company_holidaydate")
      ) {
        props.onClose();
        Swal.fire({
          icon: "error",
          title: "Duplicate Entry",
          text: "A holiday with the selected date already exists. Please choose a different date.",
        });
      } else {
        props.onClose();
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An unexpected error occurred. Please try again later.",
        });
      }
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "An error occurred while processing your request. Please try again later.",
    });
  }

  setSubmitting(false);
};


  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing?"Update Calendar Setup" : "Create Calendar Setup"}
      subtitle={props.isEditing?"Update Calendar Setup" : "Fill out the form below creating a new calendar setup."}
    />
  );
};

export default CalendarSetupForm;
